<template>
	<div class="c-file-list flex-wrap" :class="[`s-${size}`]" @click.stop>
		<c-file v-for="(image, i) in list" :key="i" :src="image" :media="media" :preview="list"></c-file>
	</div>
</template>

<script>
	export default {
		name: 'cFileList',
		
		props: {
			value: [String, Array],
			media: {
				type: Boolean,
				default: true
			},
			size: {
				type: String,
				default: 'normal'
			}
		},

		computed: {
			list() {
				return this.value ? typeof this.value == 'string' ? this.value.split(',') : this.value : [];
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.c-file-list {
		gap: 6px;

		&.s-mini {
			>>> .c-file-media {
				width: 32px;
				height: 32px;
			}	
		}

		&.s-normal {
			>>> .c-file-media {
				width: 50px;
				height: 50px;
			}	
		}
	}
</style>
